<mat-card fxFlex>
    <div fxLayout="row" fxLayoutAlign="space-between start">
        <div class="mat-title">Annotazioni del sistema</div>
    </div>
    <mat-card-content>
        <ng-container *ngIf="annotazioniDelSistema">
            <div *ngFor="let annotazione of annotazioniDelSistemaFormatted">
                <ul>
                    <li [innerText]="annotazione"></li>
                </ul>
            </div>
        </ng-container>
    </mat-card-content>
</mat-card>
